export const GET_ALL_PIPELINES = "GET_ALL_PIPELINES"
export const SET_ALL_PIPELINES = "SET_ALL_PIPELINES"
export const CREATE_PIPELINE = "CREATE_PIPELINE"
export const DELETE_PIPELINE = "DELETE_PIPELINE"
export const UPDATE_PIPELINE = "UPDATE_PIPELINE"
export const SET_SINGLE_PIPELINE = "SET_SINGLE_PIPELINE"
export const GET_SINGLE_PIPELINE = "GET_SINGLE_PIPELINE"
export const GET_SALES_PIPELINE = "GET_SALES_PIPELINE"